(function () {
  'use strict';

  const DELIM = '<span class="breadcrumb-delimeter" aria-hidden="true">></span>';

  function normalizePath(href) {
    if (!href || href === '#') return null;
    try {
      const path = new URL(href, window.location.origin).pathname;
      return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
    } catch {
      return href.split('?')[0].split('#')[0];
    }
  }

  function collectionHandle(path) {
    if (!path) return null;
    const m = path.match(/\/collections\/([^/?#]+)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function linkFromAnchor(a) {
    if (!a) return null;
    const href = a.getAttribute('href');
    const path = normalizePath(href);
    if (!path || path === '/' || href.startsWith('gm-open:')) return null;
    const title =
      a.getAttribute('title') ||
      (a.querySelector('.gm-text') && a.querySelector('.gm-text').textContent) ||
      a.textContent ||
      '';
    return { title: title.trim(), href: path };
  }

  function parseMatchHandles(raw) {
    if (!raw) return new Set();
    const trimmed = raw.trim();
    if (trimmed.startsWith('[')) {
      try {
        const list = JSON.parse(trimmed);
        return new Set(list.map((h) => String(h).toLowerCase()).filter(Boolean));
      } catch {
        /* fall through to comma-separated */
      }
    }
    return new Set(
      trimmed
        .split(/[,\s]+/)
        .map((h) => h.toLowerCase())
        .filter(Boolean)
    );
  }

  function handlesFromPageUrl() {
    const m = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    return m ? new Set([m[1].toLowerCase()]) : new Set();
  }

  function getMatchHandles(root) {
    const fromAttr = parseMatchHandles(root.getAttribute('data-match-handles'));
    if (fromAttr.size > 0) return fromAttr;
    return handlesFromPageUrl();
  }

  function pathMatches(path, matchHandles) {
    if (!path.length || matchHandles.size === 0) return false;
    const last = path[path.length - 1];
    const h = collectionHandle(last.href);
    return h != null && matchHandles.has(h);
  }

  function considerCandidate(path, candidates, matchHandles) {
    if (pathMatches(path, matchHandles)) {
      candidates.push(path.slice());
    }
  }

  function walkContainer(container, path, candidates, matchHandles) {
    if (!container || !container.children) return;
    for (const child of container.children) {
      if (child.matches && child.matches('li.gm-item')) {
        walkLi(child, path, candidates, matchHandles);
      } else if (
        child.matches &&
        (child.matches('ul') ||
          child.matches('div.gm-submenu') ||
          child.matches('div.gm-tabs') ||
          child.matches('div.gm-grid'))
      ) {
        if (child.matches('div.gm-tabs')) {
          walkGmTabs(child, path, candidates, matchHandles);
        } else {
          walkContainer(child, path, candidates, matchHandles);
        }
      }
    }
  }

  function walkGmTabs(tabsEl, path, candidates, matchHandles) {
    const tabLinks = tabsEl.querySelector(':scope > ul.gm-tab-links');
    const tabContents = tabsEl.querySelector(':scope > ul.gm-tab-contents');
    if (!tabLinks) return;

    for (const tabLi of tabLinks.children) {
      if (!tabLi.matches('li.gm-item')) continue;
      const link = linkFromAnchor(tabLi.querySelector(':scope > a.gm-target'));
      const tabPath = link ? path.concat(link) : path.slice();
      if (link) considerCandidate(tabPath, candidates, matchHandles);

      const tabIndex = tabLi.getAttribute('data-tab-index');
      if (tabContents && tabIndex != null) {
        const panel = tabContents.querySelector(
          `:scope > li.gm-tab-content[data-tab-index="${tabIndex}"]`
        );
        if (panel) walkContainer(panel, tabPath, candidates, matchHandles);
      }
    }
  }

  function walkLi(li, path, candidates, matchHandles) {
    const link = linkFromAnchor(li.querySelector(':scope > a.gm-target'));
    const newPath = link ? path.concat(link) : path.slice();
    if (link) considerCandidate(newPath, candidates, matchHandles);

    for (const child of li.children) {
      if (child.matches('div.gm-submenu')) {
        walkContainer(child, newPath, candidates, matchHandles);
      } else if (child.matches('ul')) {
        walkContainer(child, newPath, candidates, matchHandles);
      } else if (child.matches('div.gm-tabs')) {
        walkGmTabs(child, newPath, candidates, matchHandles);
      }
    }
  }

  function getGloboMenuRoot() {
    const tpl = document.querySelector('script[type="template/html"][id^="globoMenu"]');
    if (!tpl || !tpl.textContent) return null;
    const doc = new DOMParser().parseFromString(tpl.textContent, 'text/html');
    return doc.querySelector('ul.gm-menu');
  }

  function findLongestGloboTrail(matchHandles) {
    const menuRoot = getGloboMenuRoot();
    if (!menuRoot) return null;

    const candidates = [];
    for (const li of menuRoot.children) {
      if (li.matches('li.gm-item')) {
        walkLi(li, [], candidates, matchHandles);
      }
    }

    let best = null;
    for (const path of candidates) {
      if (!best || path.length > best.length) best = path;
    }
    return best;
  }

  function trailFromPayload(data) {
    if (!data?.ok || !Array.isArray(data.trail) || data.trail.length === 0) {
      return null;
    }
    return data.trail.map((crumb) => ({
      title: crumb.title,
      href: crumb.href,
    }));
  }

  async function trailFromImportedMenu(matchHandles) {
    try {
      if (window.__CSI_BREADCRUMB_PROMISE) {
        const prefetched = trailFromPayload(await window.__CSI_BREADCRUMB_PROMISE);
        if (prefetched) return prefetched;
      }
      const url =
        window.CSI_SEARCH?.breadcrumbsUrl ||
        `${window.CSI_SEARCH?.proxyBase || '/apps/csi-search'}/breadcrumbs`;
      const params = new URLSearchParams();
      params.set('handles', [...matchHandles].join(','));
      const response = await fetch(`${url}?${params.toString()}`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;
      return trailFromPayload(await response.json());
    } catch {
      return null;
    }
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function crumbHtml(crumb) {
    return `<a href="${escapeHtml(crumb.href)}">${escapeHtml(crumb.title)}</a>`;
  }

  function renderTrailHtml(trail) {
    if (!trail || !trail.length) return '';
    return trail.map(crumbHtml).join(DELIM);
  }

  function markCurrentPage(root) {
    const ready = root.querySelector('.globo-breadcrumb-ready');
    if (ready?.querySelector('.breadcrumb-current')) return;
    const lastLink = ready?.querySelector('a:last-of-type');
    if (!lastLink) return;
    const span = document.createElement('span');
    span.textContent = lastLink.textContent;
    span.setAttribute('aria-current', 'page');
    span.className = 'breadcrumb-current';
    lastLink.replaceWith(span);
  }

  function revealTrail(root) {
    const pending = root.querySelector('.globo-breadcrumb-pending');
    const ready = root.querySelector('.globo-breadcrumb-ready');
    if (pending) pending.hidden = true;
    if (ready) ready.hidden = false;
  }

  async function run() {
    const root = document.querySelector('[data-globo-breadcrumbs]');
    if (!root) return;

    const matchHandles = getMatchHandles(root);
    if (matchHandles.size === 0) {
      revealTrail(root);
      markCurrentPage(root);
      return;
    }

    const trail =
      (await trailFromImportedMenu(matchHandles)) ||
      findLongestGloboTrail(matchHandles);
    const slot = root.querySelector('.globo-breadcrumb-trail');
    const productDelim = root.querySelector('.globo-breadcrumb-product-delim');
    if (slot && trail) {
      slot.innerHTML = renderTrailHtml(trail);
    } else if (slot && root.getAttribute('data-collection-url')) {
      const url = root.getAttribute('data-collection-url');
      const title = root.getAttribute('data-collection-title') || '';
      slot.innerHTML = crumbHtml({ href: url, title });
    }
    if (productDelim) productDelim.hidden = !(trail && trail.length);

    revealTrail(root);
    markCurrentPage(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
